export interface SimpleList {
  items: any
}

const initialState: SimpleList = {
  items: [],
}

const SET = 'list/simpleList/SET'

export const fetchItems = (curState, fetchItems: Function) => async (dispatch, getState) => {
  const items = await fetchItems()
  dispatch({
    items,
    curState,
    type: SET,
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET:
      return {
        items: action.items,
      }
    default:
      return state
  }
}

export default reducer
